import { gql } from '@apollo/client'

export const CREATE_DRIVER = gql`
  mutation CreateDriver($input: CreateDriverInput!) {
    createDriver(input: $input) {
      id
    }
  }
`

export const CHANGE_TDRIVER_DETAILS = gql`
  mutation ChangeTDriverDetails($id: UUID!, $input: ChangeTDriverDetailsInput!) {
    changeTDriverDetails(id: $id, input: $input)
  }
`
export const REQUEST_RESET_USER_ACCOUNT_PASSWORD = gql`
  mutation RequestResetUserAccountPassword($input: RequestResetUserAccountPasswordInput!) {
    requestResetUserAccountPassword(input: $input)
  }
`
export const ENABLE_DRIVER = gql`
  mutation EnableDriver($input: EnableDriverInput!) {
    enableDriver(input: $input)
  }
`

export const DISABLE_DRIVER = gql`
  mutation DisableDriver($input: DisableDriverInput!) {
    disableDriver(input: $input)
  }
`

export const CHANGE_DRIVER_DOCUMENTS = gql`
  mutation ChangeDriverDocuments($input: ChangeDriverDocumentsInput!) {
    changeDriverDocuments(input: $input)
  }
`
